import ActionUtility from "../ActionUtility";

export default class AppAction {
  static RESET_STORE = 'AppAction.RESET_STORE';
  static resetStore() {
    return ActionUtility.createAction(AppAction.RESET_STORE);
  }
}